<template>
  <div id="page-container" class="">
    <!-- Payment Mode View -->
    <div v-if="isPaidSpace" class="vx-row">
      <div class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1 mb-base">
        <vx-card :title="$t('PremiumSpace')" title-color="#000" content-color="#000">
          <p>{{$t('PremiumSpaceDescription')}}</p>
          <div class="mt-4">
            <vs-button color="primary" @click="openPaymentLink">{{$t('ProceedToPayment')}}</vs-button>
          </div>
        </vx-card>
      </div>
    </div>

    <!-- Regular Content View -->
    <div v-else>
      <vs-popup :title="$t('PropertiesTitle')" :active.sync="InPropertiesMenu" v-if="InPropertiesMenu">
        <TabContainer :onboarding="selectedOnboarding"></TabContainer>
      </vs-popup>
      <vs-popup :title="$t('ShareSpace')" :active.sync="InShareSpaceMode" v-if="InShareSpaceMode">
        <ShareComponent :shareObjectType="'1'" :shareObjectId="this.$router.currentRoute.params.spaceid"></ShareComponent>
      </vs-popup>
      <vs-popup :title="$t('AssignSpace')" :active.sync="InAssignOnboardingMode" v-if="InAssignOnboardingMode" fullscreen>
        <AssignComponent :shareObjectType="'1'" :shareObjectId="this.$router.currentRoute.params.spaceid"></AssignComponent>
      </vs-popup>
      <vs-popup :title="$t('Verification')" :active.sync="InEmailInputMode" v-if="InEmailInputMode">
        <div class="vx-row">
          <div class="vx-col md:w-1/1 w-full mb-base">
          </div>
          <div class="vx-col md:w-1/1 w-full mb-base">
            {{$t('PleaseEnterYourEmail')}}
            <p>{{$t('EmailLabel')}}</p>
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      :label-placeholder="$t('EmailLabel')"
                      v-model="InputEmail" />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-base">
            <vs-button @click="VerifyEmail(InputEmail)">{{$t('Send')}}</vs-button>
          </div>
        </div>
      </vs-popup>

      <vs-popup :title="$t('AssignToRole')" :active.sync="InAssignToRoleMode" v-if="InAssignToRoleMode">
        <AssignToRoleComponent :shareObjectType="'1'" :shareObjectId="Number($router.currentRoute.params.spaceid)"></AssignToRoleComponent>
      </vs-popup>

      <vs-popup :title="$t('PinVerification')" :active.sync="InAuthorizationMode" v-if="InAuthorizationMode">
        <div class="vx-row">
          <div class="vx-col md:w-1/1 w-full mb-base">
            {{$t('CodeSentPrompt')}}
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      :label-placeholder="$t('YourCode')"
                      v-model="password" />
          </div>
        </div>
        {{$t('DidntReceiveCode')}}<a class="pointer" @click="ResendEmail">{{$t('ClickHereToResend')}}</a>
        <div>
          <a v-if="isKnownUser" class="pointer" @click="sendLoginLink">{{$t('ClickHereToLogin')}}</a>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-base">
            <vs-button @click="ValidatePIN(password)">{{$t('Validate')}}</vs-button>
          </div>
        </div>
      </vs-popup>

      <vs-popup :title="$t('CreateSubspace')" :active.sync="InSpaceCreationMode" v-if="InSpaceCreationMode">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" :label-placeholder="$t('TitleLabel')" v-model="spaceTitle" />
          </div>
          <div class="vx-col w-full mb-base">
            <vs-textarea class="vx-col w-1/1 lg:w-1/1" style="width:100%;" :label-placeholder="$t('DescriptionLabel')" v-model="spaceDescription" />
          </div>
          <!--<div class="vx-col w-full mb-base">
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Subscription ID" v-model="spaceSubscriptionId" />
          </div>
          <div class="vx-col w-full mb-base">
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Payment Link" v-model="spacePaymentLink" />
          </div>
          <div class="vx-col w-full mb-base">
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Title" v-model="certificateTitle" />
          </div>
          <div class="vx-col w-full mb-base">
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Icon Path" v-model="certificateIcon" />
            <input type="file" @change="uploadCertificateIcon($event)" accept="image/*" style="margin-top: 8px;" />
          </div>
          <div class="vx-col w-full mb-base">
            <vs-textarea class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Description" v-model="certificateDescription" />
          </div>-->
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-base">
            <vs-button typeof="flat" @click="CreateSubspace()">{{$t('CreateSpace')}}</vs-button>
          </div>
        </div>
      </vs-popup>

      <vs-popup title="Edit onboarding" :active.sync="InSpaceEditMode" v-if="InSpaceEditMode">
        <EditSpace :space="selectedSpace"></EditSpace>
      </vs-popup>

      <span style="float:right;" v-if="(subspaces.length > 0 || onboardings.length > 0)">
        <FeatherIcon v-if="$acl.check('editor')" @click="OpenShareSpaceMenu" class="tool pointer" :title="$t('Share')" icon="ShareIcon" style="position:unset;"></FeatherIcon>
        <FeatherIcon v-if="$acl.check('editor')" @click="ExportPDFSlides" class="tool pointer" :title="$t('PDFLinkedInFormat')" icon="LinkedinIcon" style="position:unset;"></FeatherIcon>
        <FeatherIcon v-if="$acl.check('editor')" @click="ExportOfflineHtml" class="tool pointer" :title="$t('HTMLFull')" icon="HardDriveIcon" style="position:unset;"></FeatherIcon>
        <FeatherIcon v-if="$acl.check('editor')" @click="OpenAssignOnboarding" class="tool pointer" :title="$t('AssignSpaceToUser')" icon="UserPlusIcon" style="position:unset;"></FeatherIcon>
        <FeatherIcon v-if="$acl.check('editor')" @click="OpenAssignToRoleMenu" class="tool pointer" :title="$t('AssignToRole')" icon="UsersIcon" style="position:unset;"></FeatherIcon>
        <FeatherIcon :active.sync="AuthorizedUserActions" v-if="AuthorizedUserActions && $acl.check('editor')" @click="OpenSpaceCreationMenu" class="tool pointer" :title="$t('AddSubspace')" icon="PlusIcon" style="position:unset;"></FeatherIcon>
        <FeatherIcon v-if="$acl.check('editor')" :class="{ 'disabled-button': !InGridView }" class="tool pointer" @click="EnableGridView" :title="$t('GridView')" icon="GridIcon" style="position:unset;"></FeatherIcon>
        <FeatherIcon v-if="$acl.check('editor')" :class="{ 'disabled-button': !InListView }" class="tool pointer" @click="EnableListView" :title="$t('ListView')" icon="ListIcon" style="position:unset;"></FeatherIcon>
      </span>
      <h1 v-if="IsLoaded && subspaces && subspaces.length > 0"> {{$t('Folders')}}</h1>
      <FeatherIcon :active.sync="InSubspace" v-if="InSubspace" class="tool pointer" @click="goBackToPreviousSpace" title="Go back" icon="CornerLeftUpIcon" style="position:unset;"></FeatherIcon>
      <div :active.sync="InGridView" v-if="InGridView" class="vx-row pt-5" style="clear:both;">
        <div v-for="(subspace) in subspaces" :key="subspace.id"
             class="vx-col w-full md:w-1/3 lg:w-1/3 xl:h-1/3 mb-base">
          <vx-card :style="'position:relative;z-index:0 ;cursor: pointer; background-size: cover; background-repeat: no-repeat; color:black;'"
                   :title="subspace.title"
                   title-color="#000"
                   content-color="#000"
                   @CardClick="openSubspace(subspace.id,subspace.parentId)"
                   class="">
            <p>
              {{ subspace.title ? subspace.description : $t('NoDescriptionYet') }}
            </p>
            <div slot="footer">
              <vs-row vs-justify="flex-end">
                &nbsp;
                <FeatherIcon v-if="!$acl.check('editor')" class="tool pointer" icon="FolderIcon" style="position:absolute; top:10px; left:10px;"></FeatherIcon>
                <vs-button v-if="$acl.check('editor')" @click.stop="OpenSpaceEditMenu(subspace)" class="mr-5" color="primary" type="flat">{{$t('Edit')}}</vs-button>
                <vs-button v-if="$acl.check('editor')" @click.stop="DeleteSpace(subspace.id)" color="danger" type="flat">{{$t('Delete')}}</vs-button>
              </vs-row>
            </div>

          </vx-card>
        </div>
        <vx-card v-if="LoadedEmptySubspaceSet && false" :title="$t('NoSubspacesHere')" title-color="#000" content-color="#000" class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
          <p>
            {{$t('NothingHere')}}
          </p>
        </vx-card>
      </div>

      <h1 v-if="IsLoaded && !LoadedEmptySet">{{$t('SOPs')}}</h1>
      <div :active.sync="InGridView" v-if="InGridView" class="vx-row pt-5" style="clear:both;">
        <div v-for="(onboarding) in onboardings" :key="onboarding.id"
             class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
          <OnboardingCard :onboarding="onboarding"></OnboardingCard>
        </div>
        <div v-if="LoadedEmptySet && (!subspaces || subspaces.length === 0)" class="vx-col w-full">
          <NoItemsCard :title="$t('NoSOPsInThisSpace')"
                       :description="$t('NoSOPsInThisSpaceDesc')"
                       v-bind:inNoItemsSpace="true"
                       @create-subspace="OpenSpaceCreationMenu" />
        </div>
      </div>

      <FeatherIcon :class="{ 'disabled-class': !ChangedOrder }" class="tool pointer float-right mt-8" :active.sync="InListView" v-if="InListView" @click="ReorderOnboardings" :title="$t('SaveOnboardingOrder')" icon="SaveIcon" style="position: unset; z-index: 999999; "></FeatherIcon>
      <div v-if="InListView">
        <div class="mt-5">
          <vs-list>
            <vs-list-header :title="$t('OnboardingsHeader')" color="primary"></vs-list-header>
            <draggable v-on:change="alertChanged()" :list="onboardings" class="cursor-move">
              <transition-group>
                <vs-list-item class="list-item" v-for="item in onboardings" :key="item.id" :title="item.name" :subtitle="item.description">
                  <vs-button color="dark" target :href="'/pages/pdf-view?oid=' + item.id">{{$t('Open')}}</vs-button>
                </vs-list-item>
              </transition-group>
            </draggable>
          </vs-list>
        </div>
      </div>

      <FeatherIcon :class="{ 'disabled-class': !ChangedSubspacesOrder }" class="tool pointer float-right mt-8" :active.sync="InListView" v-if="InListView" @click="ReorderSubspaces()" :title="$t('SaveSubspaceOrder')" icon="SaveIcon" style="position:unset;z-index:999999;"></FeatherIcon>
      <div v-if="InListView">
        <div class="mt-5">
          <vs-list>
            <vs-list-header :title="$t('SubspacesHeader')" color="primary"></vs-list-header>
            <draggable v-on:change="alertSubspacesChanged()" :list="subspaces" class="cursor-move">
              <transition-group>
                <vs-list-item class="list-item" v-for="item in subspaces" :key="item.id" :title="item.title" :subtitle="item.description">
                </vs-list-item>
              </transition-group>
            </draggable>
          </vs-list>
        </div>
      </div>

    </div>
    <PDFProgressPopup :active="pdfProgressActive"
                      :current-step="pdfCurrentStep"
                      :total-steps="pdfTotalSteps"
                      @close="pdfProgressActive = false" />
  </div>
</template>

<script>
  import { AclRule } from 'vue-acl'
  import OnboardingCard from '@/views/components/organisms/cards/OnboardingCard.vue'
  import accountsService from '../accounts/accountsService';
  import AccountService from '@/accounts/accountsService.js';
  import DeleteOnboardingLink from '@/views/components/atoms/onboardings/DeleteOnboardingLink'
  import TabContainer from '@/views/ui-elements/tabs/TabContainer.vue'
  import ShareComponent from '@/views/components/extra-components/share/ShareComponent.vue';
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import draggable from 'vuedraggable'
  import AssignComponent from '@/views/components/extra-components/assign/AssignComponent.vue';
  import AssignToRoleComponent from '@/views/components/extra-components/assign/AssignToRoleComponent.vue';
  import Prism from 'vue-prism-component'
  import EditSpace from '@/views/components/spaces/EditSpace.vue'
  import FeatherIcon from "@/components/FeatherIcon.vue";
  import PDFProgressPopup from '@/views/components/extra-components/pdf-progress/PDFProgressPopup.vue';
  import { preparePDFEnvironment } from '@/utils/PDFWorker';
  import NoItemsCard from '@/components/NoItemsCard.vue';

  //import tiptap from "@/views/components/extra-components/editors/tiptap.vue";

  export default {
    data() {
      return {
        itemsPerPage: 20,
        onboardings: [],
        subspaces: [],
        spaceTitle: "",
        spaceDescription: "",
        spaceSubscriptionId: "",
        spacePaymentLink: "",
        isKnownUser: false,
        guestEmail: null,
        InSpaceCreationMode: false,
        IsLoaded: false,
        AuthorizedUserActions: false,
        selectedOnboarding: null,
        InPropertiesMenu: false,
        InShareSpaceMode: false,
        InEmailInputMode: false,
        InAssignOnboardingMode: false,
        InAssignToRoleMode: false,
        ChangedOrder: false,
        ChangedSubspacesOrder: false,
        InGridView: true,
        onboardingPositionTracker: null,
        subspacesPositionTracker: null,
        InListView: false,
        InAuthorizationMode: false,
        InputEmail: "",
        LoadedEmptySet: false,
        LoadedEmptySubspaceSet: false,
        previousSpace: [],
        InSubspace: false,
        InSpaceEditMode: false,
        selectedSpace: null,
        hideSpaceFromSidebar: false,
        isPaidSpace: false,
        currentSpacePaymentLink: "",
        currentSpaceSubscriptionId: "",
        pdfProgressActive: false,
        pdfCurrentStep: 0,
        pdfTotalSteps: 0
      }
    },

    mounted() {
      if (accountsService.getUserFromLocalStorage() != null) {
        if (this.$route.query.spaceToken != null) {
          this.AuthorizeLoggedInUser(this.$router.currentRoute.params.spaceid, this.$route.query.spaceToken)
        }
        else {
          this.AuthorizedUserActions = true;
          this.FetchCurrentSpace();
        }
      }
      else {
        if (this.$route.query.spaceToken != null) {
          // For shared links with tokens, authenticate as anonymous user first
          this.authenticateAsAnonymousUser().then(() => {
            this.IsSharedSpace(this.$router.currentRoute.params.spaceid, this.$route.query.spaceToken);
          });
        } else {
          this.IsSharedSpace(this.$router.currentRoute.params.spaceid, this.$route.query.spaceToken);
        }
      }

    },

    methods: {

      async authenticateAsAnonymousUser() {
        // Call refreshUser to create an anonymous user session
        try {
          await AccountService.refreshUser();
          console.log('Authenticated as anonymous user for shared space access');
        } catch (error) {
          console.error('Failed to authenticate as anonymous user:', error);
          // Continue anyway - the user can still access the shared content
        }
      },

      ExportPDFSlides() {
        (async () => {
          const { doc, pageSizeMM } = await preparePDFEnvironment();

          const elements = document.querySelectorAll('.vx-card.card-tall');
          if (elements.length === 0) {
            console.warn("No .vx-card.card-tall elements found.");
            return;
          }

          // Show progress popup
          this.pdfProgressActive = true;
          this.pdfTotalSteps = elements.length;

          for (let i = 0; i < elements.length; i++) {
            this.pdfCurrentStep = i + 1;

            const el = elements[i];
            const titleText = el.querySelector('.vx-card__title h4')?.innerText?.trim() || '';
            const descText = el.querySelector('.vx-card__body > p')?.innerText?.trim() || '';
            const imgEl = el.querySelector('.vx-card__body > img');
            const imgSrc = imgEl ? imgEl.src : '';

            // Build new layout
            const layout = document.createElement('div');
            layout.style.width = '1080px';
            layout.style.height = '1080px';
            layout.style.padding = '60px 80px';
            layout.style.paddingTop = '108px'; // push everything down by ~10%
            layout.style.boxSizing = 'border-box';
            layout.style.display = 'flex';
            layout.style.flexDirection = 'column';
            layout.style.alignItems = 'flex-start';
            layout.style.justifyContent = 'flex-start';
            layout.style.background = 'linear-gradient(299deg, #69029a 0%, #000 100%)';
            layout.style.fontFamily = '"Outfit", sans-serif';
            layout.style.color = 'white';

            const h1 = document.createElement('h1');
            h1.textContent = titleText;
            h1.style.fontWeight = '900';
            h1.style.fontSize = '72px';
            h1.style.margin = '0 0 42px 0';
            h1.style.color = 'white';

            const desc = document.createElement('p');
            desc.textContent = descText;
            desc.style.fontSize = '56px';
            desc.style.margin = '0 0 30px 0';
            desc.style.maxWidth = '80%';
            desc.style.color = 'white';

            const image = document.createElement('img');
            image.src = imgSrc;
            image.style.alignSelf = 'center';
            image.style.maxWidth = '80%';
            image.style.height = 'auto';
            image.style.objectFit = 'contain';
            image.style.borderRadius = '12px';
            image.style.marginTop = '108px';

            layout.appendChild(h1);
            layout.appendChild(desc);
            layout.appendChild(image);

            const container = document.createElement('div');
            container.style.position = 'fixed';
            container.style.left = '-9999px';
            container.style.width = '1080px';
            container.style.height = '1080px';
            container.appendChild(layout);
            document.body.appendChild(container);

            const canvas = await html2canvas(layout, { scale: 2 });
            const imgData = canvas.toDataURL('image/jpeg', 1.0);

            const imgWidthPx = canvas.width;
            const imgHeightPx = canvas.height;
            const imgWidthMM = 1080; //pxToMm(imgWidthPx);
            const imgHeightMM = 1080; //pxToMm(imgHeightPx);

            const scale = Math.min(pageSizeMM / imgWidthMM, pageSizeMM / imgHeightMM);
            const finalWidth = imgWidthMM * scale;
            const finalHeight = imgHeightMM * scale;
            const marginX = (pageSizeMM - finalWidth) / 2;
            const marginY = (pageSizeMM - finalHeight) / 2;

            if (i > 0) doc.addPage();
            doc.addImage(imgData, 'JPEG', marginX, marginY, finalWidth, finalHeight);

            document.body.removeChild(container);
          }

          doc.save('linkedin-carousel.pdf');
          this.pdfProgressActive = false;
        })();
      },
      ExportOfflineHtml() {
        (async () => {
          // Show progress overlay
          const overlay = document.createElement("div");
          overlay.id = "tcvelik-progress-overlay";
          overlay.innerHTML = `
    <div style="position: fixed; top:0; left:0; width:100%; height:100%;
                background: rgba(255,255,255,0.8); z-index:9999;
                display: flex; align-items: center; justify-content: center; flex-direction: column;
                font-family: 'Outfit', sans-serif; font-size: 1.5rem; color: #198754;">
      <div class="spinner-border text-success mb-3" role="status"></div>
      <div id="tcvelik-progress-text">Starting export...</div>
    </div>`;
          document.body.appendChild(overlay);

          const setProgressText = (text) => {
            const txt = document.getElementById("tcvelik-progress-text");
            if (txt) txt.innerText = text;
          };

          // Step 1: Fetch GraphQL data
          setProgressText("Fetching SOP data...");
          const endpoint = "/api/graphql";
          const query = `
    query {
      onboardingsInSpace {
        onboarding {
          id
          name
          description
          rawContent
        }
        space {
          id
          title
          description
          parentId
        }
      }
    }
  `;
          const response = await fetch(endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ query }),
          });
          const data = await response.json();
          const onboardings = data.data.onboardingsInSpace;

          // Step 2: Extract current space from URL
          const currentSpaceId = parseInt(window.location.pathname.split("/").pop(), 10);

          // Step 3: Build space map
          const allSpacesMap = new Map();
          for (const item of onboardings) {
            const space = item.space;
            if (!allSpacesMap.has(space.id)) {
              allSpacesMap.set(space.id, {
                id: space.id,
                parentId: space.parentId,
                title: space.title,
                description: space.description
              });
            }
          }

          // Step 4: Collect descendants of current space
          const allowedSpaceIds = new Set();
          function collectDescendants(spaceId) {
            allowedSpaceIds.add(spaceId);
            for (const [id, space] of allSpacesMap.entries()) {
              if (space.parentId === spaceId && !allowedSpaceIds.has(space.id)) {
                collectDescendants(space.id);
              }
            }
          }
          collectDescendants(currentSpaceId);

          // Step 5: Filter onboardings by allowed space IDs
          const filtered = onboardings.filter(item =>
            allowedSpaceIds.has(item.space.id)
          );

          // Step 6: Group filtered onboardings by space
          const grouped = new Map();
          for (const item of filtered) {
            const sid = item.space.id;
            if (!grouped.has(sid)) {
              grouped.set(sid, {
                title: item.space.title,
                description: item.space.description,
                sops: []
              });
            }
            grouped.get(sid).sops.push({
              id: item.onboarding.id,
              title: item.onboarding.name,
              description: item.onboarding.description,
              rawContent: item.onboarding.rawContent
            });
          }

          // Step 7: Inline step extraction
          const extractSteps = async (html) => {
            const wrap = document.createElement("div");
            wrap.innerHTML = html;
            const steps = [...wrap.querySelectorAll("div[data-type='draggable-item']")];
            const result = [];

            for (const step of steps) {
              const ps = step.querySelectorAll("p");
              const title = ps[0]?.innerText || "";
              const contentNode = ps[1] || step.querySelector("div, img");
              if (!contentNode) continue;

              const imgs = contentNode.querySelectorAll?.("img") || [];
              await Promise.all([...imgs].map(async img => {
                try {
                  const res = await fetch(img.src);
                  const blob = await res.blob();
                  const reader = new FileReader();
                  const done = new Promise(resolve => {
                    reader.onloadend = () => {
                      img.src = reader.result;
                      img.style.width = "1000px";
                      img.style.maxWidth = "none";
                      resolve();
                    };
                  });
                  reader.readAsDataURL(blob);
                  await done;
                } catch (err) { }
              }));

              result.push({ title, content: contentNode.outerHTML });
            }
            return result;
          };

          // Step 8: Build HTML content
          let sidebarLinks = "";
          let contentBlocks = "";
          for (const [sid, space] of grouped.entries()) {
            setProgressText(`Processing: ${space.title}`);
            const spaceId = `space-${sid}`;
            sidebarLinks += `<a href="#${spaceId}">${space.title}</a>`;
            contentBlocks += `<div class="sop-section"><h2 id="${spaceId}">${space.title}</h2><p class="text-muted">${space.description}</p>`;

            for (const sop of space.sops) {
              const sopId = `sop-${sop.id}`;
              sidebarLinks += `<a href="#${sopId}" class="ps-3">${sop.title}</a>`;
              contentBlocks += `<h3 id="${sopId}">${sop.title}</h3><p>${sop.description}</p>`;
              const steps = await extractSteps(sop.rawContent);
              for (const step of steps) {
                contentBlocks += `<div class="step"><strong>${step.title}</strong><div>${step.content}</div></div>`;
              }
            }
            contentBlocks += `</div>`;
          }

          // Step 9: Generate final HTML
          setProgressText("Generating file...");
          const html = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>TCVelik SOPs</title>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;700;900&display=swap" rel="stylesheet">
  <style>
    body { font-family: 'Outfit', sans-serif; background-color: #f8f9fa; }
    .sidebar {
      position: fixed; top: 0; left: 0; height: 100vh; width: 250px;
      padding: 2rem 1rem; background-color: #fff;
      border-right: 2px solid #62d51f; overflow-y: auto;
    }
    .content { margin-left: 270px; padding: 2rem; background-color: #ffffff; }
    .sop-section { margin-bottom: 3rem; }
    .step {
      border-left: 4px solid #62d51f;
      padding-left: 1rem; margin-bottom: 1rem;
      background: #ffffff; padding: 1rem;
      box-shadow: 0 0 10px rgba(0,0,0,0.03);
    }
    .step img {
      width: 1000px !important;
      max-width: none !important;
      height: auto;
      margin-top: 0.5rem;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
    .sidebar a {
      display: block; margin: 0.5rem 0;
      color: #198754; text-decoration: none; font-weight: 400;
    }
    .sidebar a:hover { text-decoration: underline; }
    h1 { font-weight: 900; color: #198754; margin-bottom: 2rem; }
    h2 { font-weight: 900; color: #000; border-bottom: 1px solid #dee2e6; padding-bottom: 0.5rem; }
    h3 { font-weight: 700; color: #198754; margin-top: 2rem; }
  </style>
</head>
<body>
  <div class="sidebar">
    <h5 class="mb-4">TCVelik Docs</h5>
    ${sidebarLinks}
  </div>
  <div class="content">
    <h1>TCVelik SOP Export</h1>
    ${contentBlocks}
  </div>
</body>
</html>
`;

          // Step 10: Trigger download
          setProgressText("Downloading...");
          const blob = new Blob([html], { type: "text/html" });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "tcvelik-sops-export.html";
          link.click();

          // Step 11: Remove overlay
          document.getElementById("tcvelik-progress-overlay")?.remove();
        })();

      },
      alertChanged() {
        if (this.onboardingPositionTracker != null && this.onboardingPositionTracker != JSON.stringify(this.onboardings)) {
          this.ChangedOrder = true;
        }
        else {
          this.ChangedOrder = false;
        }
      },
      getAbsoluteSpacepath(newRelativePath) {
        // Get the current URL
        const currentUrl = new URL(window.location.href);

        // Set the new relative path
        currentUrl.pathname = newRelativePath;

        // Return the modified URL as a string
        return currentUrl.toString();
      },
      alertSubspacesChanged() {
        if (this.subspacesPositionTracker != null && this.subspacesPositionTracker != JSON.stringify(this.subspaces)) {
          this.ChangedSubspacesOrder = true;
        }
        else {
          this.ChangedSubspacesOrder = false;
        }
      },
      isOnboardingCompleted(onboarding) {
        return onboarding.currentUserStats != null && onboarding.currentUserStats == 'COMPLETED';
      },

      openSubspace(id, parentId) {
        this.InSubspace = true
        this.previousSpace.push(parentId)
        this.$router.replace({
          name: 'spacesDetailsPage',
          params: { spaceid: id }
        });
      },

      goBackToPreviousSpace() {
        var lastSpace = this.previousSpace.pop()
        this.$router.replace({
          name: 'spacesDetailsPage',
          params: { spaceid: lastSpace }
        });
      },

      CreateSubspace() {
        var instance = this
        const spaceVariables = {
          id: 0,
          title: instance.spaceTitle,
          description: instance.spaceDescription,
          icon: "",
          urlName: "",
          hideFromSidebar: instance.hideSpaceFromSidebar,
          parentId: instance.$router.currentRoute.params.spaceid * 1,
          subscriptionId: instance.spaceSubscriptionId,
          paymentLink: instance.spacePaymentLink
        }
        const query = `
     mutation AddSubspace($space: SpaceInput!) {
       addSubspace(entity: $space) {
         id,
         title,
         description,
         icon,
         urlName,
         hideFromSidebar,
         parentId,
         subscriptionId,
         paymentLink
         }
  }
 `;
        const variables = {
          space: spaceVariables
        }

        const req = {
          query,
          variables
        };
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data.data) {
            instance.spaceTitle = ""
            instance.spaceDescription = ""
            instance.InSpaceCreationMode = false
            instance.FetchSubspaces()
            instance.$vs.notify({
              title: instance.$t('SuccessExclamation'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :( ');
            console.error("ERROR SAVING ONBOARDING: ", response.data);
          }
        });

      },

      DeleteSpace(spaceId) {
        if (confirm("Are you sure?The SOPs in this space will still be available in the 'Discover' section.")) {

        } else {
          return;
        }
        var instance = this
        const query = `
    mutation DeleteSpace($spaceId:Int!) {
    deleteSpace(spaceId: $spaceId)
 }
`;
        const variables = {
          spaceId: spaceId
        }

        const req = {
          query,
          variables
        };
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data) {

            instance.$vs.notify({
              title: instance.$t('SuccessfullyDeletedSubspace'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            location.reload()
          }
          else if (response && response.data && response.data.errors) {
            instance.$vs.notify({
              title: instance.$t('ProblemOccurredDeletingSubspace'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            console.error("ERROR SAVING ONBOARDING: ", response.data);
          }
        });
      },

      OpenProperties(onboarding) {
        this.InPropertiesMenu = true;
        this.selectedOnboarding = onboarding
      },
      OpenSpaceCreationMenu() {
        this.InSpaceCreationMode = true;
      },

      EnableGridView() {
        this.InGridView = true;
        this.InListView = false;
      },

      EnableListView() {
        this.InGridView = false;
        this.InListView = true;
      },

      IsSharedSpace(spaceId, token) {
        var instance = this
        TCVelikClient.PostRelative("/api/share/IsSharedSpace?SpaceId=" + spaceId + "&token=" + token).then(function (response) {
          if (response) {
            if (response.data == 0) {
              instance.ValidateToken(token, spaceId)
            }
            else {
              instance.InEmailInputMode = true;
            }

          }
          else if (token == undefined) {
            document.location.href = "/pages/login"
          }
        }).catch(err => {
          document.location.href = "/pages/login"
        });

      },

      AuthorizeLoggedInUser(targetObjectId, token) {
        var instance = this;
        instance.$vs.loading()
        TCVelikClient.PostRelative("/api/share/AuthorizeLoggedInUser/?targetObjectId=" + targetObjectId + "&token=" + token).then(function (response) {
          if (response) {
            instance.$vs.loading.close()
            instance.AuthorizedUserActions = true;
            instance.FetchOnboardings()
          }
        }).catch(err => {
          instance.$vs.loading.close()
          document.location.href = "/pages/login"
        });

      },

      OpenSpaceEditMenu(space) {
        this.InSpaceEditMode = true;
        this.selectedSpace = space;
      },


      ValidatePIN(pin) {
        var instance = this
        TCVelikClient.PostRelative("/api/share/VerifyPIN?pin=" + pin + "&token=" + instance.$route.query.spaceToken).then(function (response) {
          if (response && response.status == 200) {
            instance.InAuthorizationMode = false;
            localStorage.setItem(location.hostname + "-token", response.data.token);
            accountsService.refreshUser();
            instance.FetchOnboardings();
            let url = new URL(window.location.href);
            let token = url.searchParams.get("token");
            if (token) {
              url.searchParams.delete("token");
              history.pushState({}, '', url.href);
            }
          }
        }).catch(err => {
          instance.$vs.notify({
            text: instance.$t('InvalidPassword'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });

      },

      VerifyEmail(email) {
        var instance = this
        TCVelikClient.PostRelative("/api/share/ConfirmTargetAudience?email=" + email + "&token=" + instance.$route.query.spaceToken).then(function (response) {
          if (response) {
            instance.InEmailInputMode = false;
            instance.ValidateToken(instance.$route.query.spaceToken, instance.$router.currentRoute.params.spaceid, email)
            instance.InAuthorizationMode = true;
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('NoAccessToResource'),
            text: instance.$t('NoAccessToResourceText'),
            color: "warning",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
            time: 5000,
          });
        });
      },

      ResendEmail() {
        var instance = this
        TCVelikClient.PostRelative("/api/share/SendVerificationEmail?OnboardingId=" + instance.$router.currentRoute.params.spaceid + "&token=" + instance.$route.query.token + "&forceEmailOnExistingToken=" + true).then(function (response) {
          if (response && response.status == 200) {
            instance.InAuthorizationMode = true;
            instance.$vs.notify({
              title: instance.$t('CodeSentToEmail'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          alert("Invalid link.")
        });
      },

      ValidateToken(token, spaceId, email) {
        var instance = this
        if (token == undefined) {
          alert("This page cannot be accessed.")
          return;
        }
        TCVelikClient.PostRelative("/api/share/SendVerificationEmail?OnboardingId=" + spaceId + "&token=" + token + "&email=" + email + "").then(function (response) {
          if (response && response.status == 200) {
            if (response.data.existingUser != null) {
              instance.guestEmail = response.data.existingUser
              instance.isKnownUser = true
            }
            instance.InAuthorizationMode = true;
            instance.$vs.notify({
              title: instance.$t('CodeSentToEmail'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
          else if (response.status == 202) {
            if (response.data.existingUser != null) {
              instance.guestEmail = response.data.existingUser
              instance.isKnownUser = true
            }
            instance.InAuthorizationMode = true;
            instance.$vs.notify({
              title: instance.$t('CodeAlreadySentToEmail'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          alert("Invalid link.")
        });
      },

      OpenShareSpaceMenu() {
        this.InShareSpaceMode = true;
      },

      OpenAssignOnboarding() {
        this.InAssignOnboardingMode = true
      },

      OpenAssignToRoleMenu() {
        this.InAssignToRoleMode = true
      },

      OpenOnboarding(id, fromSpaceid) {
        if (document.body.getAttribute("notcv") == "true") {
          window.location.href = '/pages/liveguide/' + id;
        }
        else {
          var spaceQuery = (this.$router.currentRoute.params.spaceid && this.$router.currentRoute.params.spaceid.length > 0) ?
            "&fromspace=" + this.$router.currentRoute.params.spaceid : '';
          this.$router.push('/pages/pdf-view?oid=' + id + spaceQuery);
          //window.open('/pages/pdf-view?oid=' + id);
        }
      },
      FetchOnboardings() {
        var id = this.$router.currentRoute.params.spaceid;
        this.IsLoaded = false;
        var instance = this;
        instance.$vs.loading({
          container: '#page-container',
          scale: 0.6
        })
        var req = JSON.stringify({
          query: `query OnboardingsInSpace($id: Int) {
            onboardingsInSpace(where:{
                spaceId: {
                    eq:$id
                }
            }) {
                id
                onboardingId
                spaceId,
                currentUserStats,
                rootSpaceId,
                calculatedBreadCrumb,
                onboarding{
                    id,
                    name,
                    description,
                    firstImage
                },
                space{
                    urlName,
                    title,
                    id,
                    parentId
                 },
            }
        }`,
          variables: {
            id: id * 1  // Ensure the id is an integer
          }
        });

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.onboardings = response.data.data.onboardingsInSpace.map(os => ({
              ...os.onboarding,
              currentUserStats: os.currentUserStats // or any other property from response.data
            }));
            
            // Set space title and update document title for better analytics tracking
            if (response.data.data.onboardingsInSpace.length > 0) {
              instance.spaceTitle = response.data.data.onboardingsInSpace[0].space.title;
              document.title = instance.spaceTitle;
            } else {
              // Handle empty space - use space title from FetchCurrentSpace or fallback
              if (instance.spaceTitle) {
                document.title = instance.spaceTitle;
              }
            }
            
            // Note: seoReady() is called by FetchCurrentSpace() to avoid duplicate tracking
            
            instance.onboardingPositionTracker = JSON.stringify(instance.onboardings);
            instance.IsLoaded = true
            instance.$vs.loading.close("#page-container > .con-vs-loading")
            if (instance.onboardings.length == 0) {
              instance.LoadedEmptySet = true;
            }
            else {
              instance.LoadedEmptySet = false;
            }
          }
        });
      },

      FetchSubspaces() {
        var id = this.$router.currentRoute.params.spaceid;
        var instance = this;
        instance.$vs.loading({
          container: '#page-container',
          scale: 0.6
        })
        var req = JSON.stringify({
          query: `query Subspaces($id: Int) {
     subspaces(where:{
         parentId: {
             eq:$id
         }
     }) {
        id
        title
        description
        icon
        urlName
        hideFromSidebar
        rootId
        parentId
        ordinalPosition
        subscriptionId
        paymentLink
     }
 }`,
          variables: {
            id: id * 1  // Ensure the id is an integer
          }
        });

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.subspaces = response.data.data.subspaces
            instance.subspacesPositionTracker = JSON.stringify(instance.subspaces)
            if (instance.subspaces.length > 0) {
              if (response.data.data.subspaces[0].parentId == response.data.data.subspaces[0].rootId) {
                instance.InSubspace = false
              }
              else {
                instance.InSubspace = true
              }
            }
            instance.$vs.loading.close("#page-container > .con-vs-loading")
            if (instance.subspaces.length == 0) {
              instance.LoadedEmptySubspaceSet = true;
            }
            else {
              instance.LoadedEmptySubspaceSet = false;
            }
          }
          else {
            console.log(response)
          }
        });
      },

      ReorderOnboardings() {
        var instance = this;
        var spaceId = instance.$router.currentRoute.params.spaceid
        const mappedArray = instance.onboardings.map((item, index) => ({
          spaceId: spaceId * 1,
          onboardingId: item.id * 1,
          position: index,
        }));
        var req = JSON.stringify({
          query: `mutation ReorderOnboardings($items:[ReorderItemDTOInput!]!) {
          reorderOnboardings(items: $items)
}`,
          variables: {
            items: mappedArray
          }
        });

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.$vs.notify({
              title: instance.$t('SavedOrderOfOnboardings'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            instance.ChangedOrder = false,
              instance.onboardingPositionTracker = JSON.stringify(instance.onboardings)
          }
          else if (response && response.data.errors) {
            instance.$vs.notify({
              title: instance.$t('FailedToSaveOrder'),
              color: "failure",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        });

      },

      ReorderSubspaces() {
        var instance = this;
        var parentId = instance.$router.currentRoute.params.spaceid
        const mappedArray = instance.subspaces.map((item, index) => ({
          parentId: parentId * 1,
          spaceId: item.id * 1,
          position: index,
        }));
        var req = JSON.stringify({
          query: `mutation ReorderSubspaces($items:[ReorderSubspaceDTOInput!]!) {
          reorderSubspaces(items: $items)
}`,
          variables: {
            items: mappedArray
          }
        });

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.$vs.notify({
              title: instance.$t('SavedOrderOfSubspaces'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            instance.ChangedSubspacesOrder = false,
              instance.subspacesPositionTracker = JSON.stringify(instance.subspaces)
          }
          else if (response && response.data.errors) {
            instance.$vs.notify({
              title: instance.$t('FailedToSaveOrder'),
              color: "failure",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        });

      },

      SaveChanges(onboarding) {
        const query = `
          mutation UpdateOnboarding($onboarding: OnboardingInput!) {
            updateMainFields(
              entity: $onboarding
            ) {
              id,
              name
              description
              rawContent
            }
          }
        `;

        const variables = {
          onboarding: onboarding
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            alert("You're good to go.");
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :(');
          }
        });
      },

      sendLoginLink() {
        var instance = this;
        if (confirm("Send a login link?")) {
          TCVelikClient.PostRelative("/api/accounts/SendLoginLink?ToEmail=" + instance.guestEmail).then(function (response) {
            if (response) {
              instance.loginLink = response.data.Link;
              instance.AfterShare = true;
              instance.$vs.notify({
                title: instance.$t('LinkSent'),
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                time: 5000,
              });
            }
          }).catch(err => {
            instance.$vs.notify({
              title: instance.$t('SomethingWentWrongSendingLink'),
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              time: 5000,
            });
          });
        }
        else {
          return;
        }
      },

      FetchCurrentSpace() {
        var instance = this;
        var spaceId = this.$router.currentRoute.params.spaceid;

        // Reset paid space state when fetching new space
        instance.isPaidSpace = false;
        instance.currentSpacePaymentLink = "";
        instance.currentSpaceSubscriptionId = "";

        var req = JSON.stringify({
          query: `query GetSpace($id: Int!) {
            spaces(where: { id: { eq: $id } }) {
              id
              title
              description
              subscriptionId
              paymentLink
            }
          }`,
          variables: {
            id: spaceId * 1
          }
        });

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data && response.data.data.spaces) {

            // TEMP: subspaces return 0 items which leads to
            // error message (but loads properly).
            // for now the payment check is on root space only.

            if (response.data.data.spaces.length > 0) {
              const space = response.data.data.spaces[0];

              // Update space payment info
              instance.currentSpacePaymentLink = space.paymentLink;
              instance.currentSpaceSubscriptionId = space.subscriptionId;

              // Set space title and document title for analytics tracking
              instance.spaceTitle = space.title;
              document.title = space.title;
              
              // Dispatch seoReady event for analytics tracking
              window.seoReady();

              // Check if this is a paid space
              if (space.paymentLink || space.subscriptionId) {
                // Check if user has an active subscription
                if (!instance.hasActiveSubscription()) {
                  instance.isPaidSpace = true;
                  // Clear any existing content when switching to paid space
                  instance.onboardings = [];
                  instance.subspaces = [];
                  instance.IsLoaded = true;
                  instance.$vs.loading.close("#page-container > .con-vs-loading");
                  return; // Don't load content for paid space without subscription
                }
              }
            }

            // If we get here, either:
            // 1. It's not a paid space, or
            // 2. It is a paid space but user has subscription
            // So we can load the content
            instance.FetchOnboardings();
            instance.FetchSubspaces();


          } else {
            console.error("Failed to fetch space details");
            instance.$vs.notify({
              title: instance.$t('Error'),
              text: instance.$t('CouldNotLoadSpaceDetails'),
              color: "danger",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-alert-circle",
            });
            // Still try to load content even if space check fails
            instance.FetchOnboardings();
            instance.FetchSubspaces();
          }
        }).catch(function (error) {
          console.error("Error fetching space:", error);
          instance.$vs.notify({
            title: instance.$t('Error'),
            text: instance.$t('FailedToLoadSpaceInformation'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
          });
          // Still try to load content even if space check fails
          instance.FetchOnboardings();
          instance.FetchSubspaces();
        });
      },

      openPaymentLink() {
        if (this.currentSpacePaymentLink) {
          window.open(this.currentSpacePaymentLink, '_blank');
        }
      },

      hasActiveSubscription() {
        try {
          const userInfo = JSON.parse(accountsService.getUserFromLocalStorage());
          if (!userInfo || !userInfo.User || !userInfo.User.subscriptions) {
            return false;
          }
          // Check if user has an active subscription for this space
          return userInfo.User.subscriptions.includes(this.currentSpaceSubscriptionId);
        } catch (err) {
          console.error("Error checking subscriptions:", err);
          return false;
        }
      },
    },
    watch: {
      '$route.params.spaceid': function (newVal, oldVal) {
        // Instead of directly fetching onboardings and subspaces,
        // we should first check if it's a paid space
        this.FetchCurrentSpace();
      }
    },
    components: {
      DeleteOnboardingLink,
      TabContainer,
      ShareComponent,
      draggable,
      Prism,
      FeatherIcon,
      EditSpace,
      OnboardingCard,
      AssignComponent,
      AssignToRoleComponent,
      PDFProgressPopup,
      NoItemsCard
    }
  }
</script>
<style>

  body {
    background: #fff;
    padding: 20px;
  }

  .layout--full-page {
    height: 500px;
  }

  .tool {
    margin-right: 10px;
  }

  .onboarding-recorder.email .vs-collapse-item {
    background: white !important;
  }

  .onboarding-recorder.email .vs-collapse-item--header {
    background: white !important;
  }

  .onboarding-recorder.email .step-tools {
    display: none !important;
  }

  .onboarding-recorder.email .icon-header {
    display: none !important;
  }

  .onboarding-recorder.email .screenshot {
    max-width: 300px !important;
  }

  .pointer {
    cursor: pointer;
  }

  .commands {
    position: fixed;
    bottom: 0px;
  }

  .full-height {
    height: 100%;
  }

  img.screenshot {
    max-width: 80%;
    opacity: 0.8;
  }

  .onboarding-recorder .vs-collapse-item--header {
    background: #efefef;
    margin-bottom: 10px;
  }

  .disabled-class {
    pointer-events: none;
    opacity: 0.5;
  }

  .disabled-button {
    opacity: 0.5;
  }
</style>
